<template>
    <Headify :data="headMeta" />

    <div class="min-h-screen bg-white pb-20">
        <NavMain :key="route.name" />

        <div class="flex flex-1 flex-col lg:pl-64">
            <main class="flex-1">
                <div class="mx-auto w-full max-w-7xl px-2 pt-12 sm:px-4 lg:pt-4">
                    <div class="py-2">
                        <!-- Breadcrumbs přijímají data z props -->
                        <Breadcrumbs :links="breadcrumbLinks" />
                        <ListToolbar
                            :data="listData"
                            :child-key="toolbarConfig?.childKey"
                            :result="filteredData"
                            :search="toolbarConfig.search"
                            :buttons="toolbarConfig.buttons"
                            :index-id="toolbarConfig.indexId"
                            :tags="toolbarConfig?.tags"
                        />
                    </div>

                    <!-- Slot pro child komponentu (např. TagList) -->
                    <slot></slot>
                </div>
            </main>
        </div>
    </div>

    <div
        class="fixed right-0 bottom-0 left-1 z-2000 flex h-16 items-center justify-center bg-white lg:left-64"
    >
        <Paginator
            :key="getRndKey()"
            :pagination="pagination"
        />
    </div>
</template>

<script setup>
    import { useRoute } from 'vue-router';
    import Headify from '../components/Headify.vue';
    import Breadcrumbs from '../ui/Breadcrumbs.vue';
    import ListToolbar from '../ui/ListToolbar.vue';
    import NavMain from '../ui/NavMain.vue';
    import Paginator from '../ui/Paginator.vue';
    import navs from '../composables/navs';
    import { getRndKey } from '../composables/utils';

    const route = useRoute();
    const headMeta = navs().metaFind(route.name);

    const props = defineProps({
        breadcrumbLinks: {
            type: Object,
            required: true,
        },
        listData: {
            type: Object,
            required: true,
        },
        filteredData: {
            type: Object,
            required: true,
        },
        toolbarConfig: {
            type: Object,
            required: true,
        },
        pagination: {
            type: Object,
            required: true,
        },
    });

    const breadcrumbLinks = props.breadcrumbLinks;
    const filteredData = props.filteredData;
    const listData = props.listData;
    const toolbarConfig = props.toolbarConfig;
    const pagination = props.pagination;
</script>
